import React, { useEffect } from "react";
import classes from "./Home.module.scss";

import scrollToComponent from "react-scroll-to-component";
import JIcon from "../../components/UI/Icon/JIcon";
import { Helmet } from "react-helmet";
import ReactGa from "react-ga";
import { LoadingSimple } from "../../components/UI/LoadingBar";
// import {listProducts} from "../../actions/productAction";

const CarouselBannerSection = React.lazy(() =>
  import("../../containers/Home/CarouselBannerSection")
);
const AboutJbfsSection = React.lazy(() =>
  import("../../containers/Home/AboutJbfsSection")
);
const BrandsSection = React.lazy(() =>
  import("../../containers/Home/BrandsSection")
);
const ProductCategorySection = React.lazy(() =>
  import("../../containers/Home/ProductCategorySection")
);
const FeaturedProductSectionGrid = React.lazy(() =>
  import("../../containers/Home/FeaturedProductSection")
);
const MenuIdeaSection = React.lazy(() =>
  import("../../containers/Home/MenuIdeaSection")
);
const HappyCustomerSectionGrid = React.lazy(() =>
  import("../../containers/Home/HappyCustomerSection")
);
const BannerSection = React.lazy(() =>
  import("../../containers/Home/BannerSection")
);
const NewsEventSection = React.lazy(() =>
  import("../../containers/Home/NewsEventSection")
);

const HomeHook = (props) => {
  // Use the scrollInfo at will
  useEffect(() => {
    // ============
    // console.log('useEffect 1');
    // ============
    // dispatch(listProducts())
    ReactGa.pageview(
      window.location.origin.toString() + props.location.pathname
    );
    const loadDocumentTitle = () => {
      document.title = "Home Japfa Food";
    };
    const resetLocalStorageHandler = () => {
      localStorage.removeItem("selected_category");
      localStorage.removeItem("selected_sub_category");
    };
    loadDocumentTitle();
    resetLocalStorageHandler();

    return () => {
      // context.cancel();
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.location.pathname]);

  return (
    <>
      <React.Suspense fallback={<LoadingSimple />}>
        <div
          className={["violet", classes.Home_container].join(" ")}
          ref={(section) => {
            scrollToComponent.Violet = section;
          }}
        >
          <Helmet>
            <meta
              name="description"
              content="JAPFA FOOD: The all in one solution for your F&B needs. We provides a variety of animal proteins:  chicken, wagyu beef, fish, dairy, processed meat, sauces and seasonings. We offers custom support tailored to the needs of our food service partners."
            />
            {/* <meta
              name="keywords"
              content="food service, frozen food, supplier frozen food, Best Chicken, Tokusen, Omayo, food catering, food service delivery, Japfa Indonesia, meat shop, Chicken shop, food solutions, JBFS, Food Supplier"
            /> */}
            <meta name="author" content="" />
            <meta
              property="og:title"
              content="Home Japfa Food | Indonesia | Food Supplier"
            />
            <meta
              property="og:description"
              content="JAPFA FOOD: The all in one solution for your F&B needs. We provides a variety of animal proteins:  chicken, wagyu beef, fish, dairy, processed meat, sauces and seasonings. We offers custom support tailored to the needs of our food service partners."
            />
            <title>{"Home Japfa Food"}</title>
            <link rel="canonical" href={window.location.origin.toString()} />
          </Helmet>
          <Helmet>
             <meta name="description" content="JAPFA FOOD : The all in one solution for your F&B needs. We provides a variety of animal proteins:  chicken, wagyu beef, fish, dairy, processed meat, sauces and seasonings. We offers custom support tailored to the needs of our food service partners."/>
             <meta name="keywords" content="food service, frozen food, supplier frozen food, Best Chicken, Tokusen, Omayo, food catering, food service delivery, Japfa Indonesia, meat shop, Chicken shop, food solutions, JBFS, Food Supplier"/>
             <meta name="author" content=""/>
             <meta property="og:title" content="Home Japfa Food | Indonesia | Food Supplier"/>
             <meta property="og:description" content="JAPFA FOOD: The all in one solution for your F&B needs. We provides a variety of animal proteins:  chicken, wagyu beef, fish, dairy, processed meat, sauces and seasonings. We offers custom support tailored to the needs of our food service partners."/>
             <title>{"Home Japfa Food | Indonesia | Food Supplier"}</title>
             <link rel="canonical" href={window.location.origin.toString()}/> 
          </Helmet>
          <CarouselBannerSection />{" "}
          {/* This is loaded from Component/JCICarousel */}
          <AboutJbfsSection />{" "}
          {/* This is loaded from Component/About JBFS Section */}
          <BrandsSection />
          {/* This is loaded from Component/Home-HomeFeaturedProduct */}
          <ProductCategorySection />
          {/* This is loaded from Component/HomeJCICategory */}
          <FeaturedProductSectionGrid />
          {/* This is loaded from Component/Home-HomeFeaturedProduct */}
          <MenuIdeaSection />
          {/* This is loaded from Component/Menu Ideas */}
          <HappyCustomerSectionGrid />
          {/* This is loaded from Component/Menu Ideas */}
          <BannerSection />
          {/* This is loaded from Banner */}
          <NewsEventSection />
          {/* This is loaded from News Section */}
          {/*</BrowserRouter>*/}
          <div className={"jbfs-arrow-top"}>
            <JIcon
              icontype={"link_to_top"}
              onClick={() =>
                scrollToComponent(scrollToComponent.Violet, {
                  offset: -99,
                  align: "top",
                  duration: 1500,
                })
              }
            />
          </div>
        </div>
      </React.Suspense>
    </>
  );
};

export default React.memo(HomeHook);
